<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <material-card icon="mdi-content-copy" :title="title" :text="text">    
                    <v-form id="form" ref="form">
                        <v-container py-0>
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <range-date-picker v-model="dataSelecionada" :required="true" :requiredText="selecionePeriodo" :label="periodo">
                                    </range-date-picker>
                                </v-flex>  

                                <v-flex xs12 md6>
                                    <v-select :label="cboPais" :items="lista.pais" return-object v-model="paisComputed"
                                        item-value="id" item-text="nome" :no-data-text="cboPaisSemDados"
                                        required :rules="rules.pais"></v-select>
                                </v-flex>    

                                <v-flex xs12 md6 v-show="dataSelecionada[0] != null">
                                    <time-picker :label="$t('Views.Onboarding.Log.Listar.hora-inicial').replace('{0}', $moment(dataSelecionada[0]).format('DD/MM/YYYY'))" v-model="horaInicial" :useSeconds="false"></time-picker>
                                </v-flex>                 

                                <v-flex xs12 md6 v-show="dataSelecionada[1] != null">
                                    <time-picker :label="$t('Views.Onboarding.Log.Listar.hora-final').replace('{0}', $moment(dataSelecionada[1]).format('DD/MM/YYYY'))" v-model="horaFinal" :useSeconds="false"></time-picker>
                                </v-flex>  

                                <v-flex xs12 md6>
                                    <v-text-field :label="labelJobReqId" v-model="jobReqId"></v-text-field>
                                </v-flex>     

                                <v-flex xs12 md6>
                                    <v-text-field :label="labelCorrelationId" v-model="correlationId"></v-text-field>
                                </v-flex>   

                                <v-flex xs12 md6>
                                    <v-select :label="cboInclusao" :items="lista.inclusaoAlteracao" return-object v-model="indicadorInclusao"
                                        item-value="id" item-text="nome"></v-select>
                                </v-flex>         

                                <v-flex xs12 md6>
                                    <v-select :label="cboErro" :items="lista.sucessoErro" return-object v-model="indicadorSucesso"
                                        item-value="id" item-text="nome"></v-select>
                                </v-flex>                                                                                                                                                                                                                                                                                                                                                                                               

                                <v-flex xs12 md12 class="d-flex justify-center">
                                    <v-btn class="danger" @click="btnLimpar_OnClick">
                                        <v-icon left>mdi-restore</v-icon> 
                                        {{clear}}
                                    </v-btn>                          
                                    <v-btn class="success" @click="btnPesquisar_OnClick">
                                        <v-icon left>mdi-filter</v-icon> 
                                        {{search}}
                                    </v-btn>                                                                              
                                </v-flex>                               
                            </v-layout>
                        </v-container>
                    </v-form> 
                    <br/>   
                    
                    <v-tabs v-model="tab"
                        fixed-tabs
                        :color="themes.primary"
                    >
                        <v-tab :key="1">{{$t('Views.Onboarding.Log.Listar.solicitacao-contratacao')}}</v-tab>
                        <v-tab :key="2">{{$t('Views.Onboarding.Log.Listar.pendente-contratacao')}}</v-tab>
                        <v-tab :key="3" v-if="!cboPaisIgualBrasil">
                            <span>{{$t('Views.Onboarding.Log.Listar.data-contratacao-real')}}</span>
                        </v-tab>
                        <v-tab :key="4" v-else>
                            <span>{{$t('Views.Onboarding.Log.Listar.retorno-PPA')}}</span>
                        </v-tab>                        
                    </v-tabs> 

                    <v-tabs-items v-model="tab">
                        <v-tab-item :key="1">
                            <solicitacao-contratacao v-model="parametrosConsulta"></solicitacao-contratacao>
                        </v-tab-item>
                        <v-tab-item :key="2">
                            <pendente-contratacao v-model="parametrosConsulta"></pendente-contratacao>
                        </v-tab-item>
                        <v-tab-item :key="3" v-if="!cboPaisIgualBrasil">
                            <data-contratacao-real v-model="parametrosConsulta"></data-contratacao-real>
                        </v-tab-item>         
                        <v-tab-item :key="4" v-else>
                            <ppa v-model="parametrosConsulta"></ppa>
                        </v-tab-item>                                     
                    </v-tabs-items>                    
                </material-card>
            </v-flex>
        </v-layout>                                                                    
    </v-container>
</template>

<script>

import { mapGetters } from 'vuex'
import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'
import PaisConstantes from '@/constants/corporativo/pais'
import DatePickerRange from '@/components/material/DatePickerRange'
import TimePicker from '@/components/material/TimePicker'
import ParametrizacaoOnboardingApi from '@/api/workspace/onboarding/parametrizacao'
import Step1 from './Steps/PendenteContratacao'
import Step2 from './Steps/SolicitacaoContratacao'
import Step3 from './Steps/DataContratacaoReal'
import Step4 from './Steps/PPA'

export default {
    mixins: [ FormMixin, DateMixin ],  
    components: {
        "range-date-picker": DatePickerRange,
        "time-picker": TimePicker,
        "pendente-contratacao": Step1,
        "solicitacao-contratacao": Step2,
        "data-contratacao-real": Step3,
        "ppa": Step4,
    },  
    watch:{
        dataSelecionada(newValue, oldValue){
            if(newValue.length > 0 && newValue[0] != null){
                newValue[0].setHours(0)
                newValue[0].setMinutes(0);
                newValue[0].setSeconds(0);
                newValue[0].setMilliseconds(0);  

                if(oldValue != undefined && oldValue != null && oldValue[0] != null){
                    newValue[0].setHours(oldValue[0].getHours())
                    newValue[0].setMinutes(oldValue[0].getMinutes());
                    newValue[0].setSeconds(oldValue[0].getSeconds());
                    newValue[0].setMilliseconds(oldValue[0].getMilliseconds());                      
                }
            }        
            
            if(newValue.length > 1 && newValue[1] != null){
                newValue[1].setHours(23)
                newValue[1].setMinutes(59);
                newValue[1].setSeconds(59); 

                if(oldValue != undefined && oldValue != null && oldValue.length > 1 && oldValue[1] != null){
                    newValue[1].setHours(oldValue[1].getHours())
                    newValue[1].setMinutes(oldValue[1].getMinutes());
                    newValue[1].setSeconds(oldValue[1].getSeconds());                 
                }                
            }    
        }
    },
    data () {
        return { 
            lista: {
                pais: [],
                inclusaoAlteracao: [],
                sucessoErro: []
            },          
            rules:{
                pais: [
                    val => {
                        if((val || null) == null)
                            return this.cboPaisObrigatorio;

                        return true;
                    }
                ]                          
            },   
            parametrosConsulta: null,
            indicadorSucesso: null,    
            indicadorInclusao: null,
            desistenciaVaga: null,
            vagaAprovada: null,
            pais: null,    
            paisGrid: null,
            paisPadraoUsuario: false,
            jobReqId: null,    
            correlationId: null, 
            dataSelecionada: [],    
            tab: 1,
        }
    },
    computed: {  
        ...mapGetters("app", ["getUserCountry"]),
        title () {
            return this.$t('Views.Onboarding.Log.Listar.form-title');            
        },          
        text () {
            return this.$t('Views.Onboarding.Log.Listar.form-text');            
        },
        periodo(){
            return this.$t('Views.Onboarding.Log.Listar.periodo');            
        },           
        selecionePeriodo(){
            return this.$t('Views.Onboarding.Log.Listar.selecione-periodo');            
        },
        cboPais(){
            return this.$t('Views.Onboarding.Log.Listar.pais');            
        },
        cboPaisSemDados(){
            return this.$t('Views.Onboarding.Log.Listar.nenhum-pais-encontrado');            
        }, 
        cboPaisObrigatorio(){
            return this.$t('Views.Onboarding.Log.Listar.selecione-pais');            
        }, 
        labelJobReqId(){
            return this.$t('Views.Onboarding.Log.Listar.job-req-id');
        }, 
        labelCorrelationId(){
            return this.$t('Views.Onboarding.Log.Listar.correlation-id');
        },         
        sucesso(){
            return this.$t('Views.Onboarding.Log.Listar.sucesso');
        },
        cboInclusao(){
            return this.$t('Views.Onboarding.Log.Listar.inclusao');            
        },      
        cboErro(){
            return this.$t('Views.Onboarding.Log.Listar.erro');            
        },     
        cboPaisIgualBrasil(){
            return (this.pais != null && this.pais.codigoSuccessFactors == PaisConstantes.brasil.codigo);
        }, 
        paisComputed: {
            get(){
                if(this.pais == null && this.getUserCountry != null && !this.paisPadraoUsuario){
                    this.$set(this, "paisPadraoUsuario", true);
                    this.$set(this, "pais", this.getUserCountry);
                }

                return this.pais;
            },
            set(value){
                this.$set(this, "pais", value);
            }
        },
        horaInicial:{
            get(){
                if(this.dataSelecionada[0] == null)
                    return null;

                return this.$moment(this.dataSelecionada[0]).format('HH:mm');
            },
            set(value){
                if(value == undefined || value.indexOf(":") < 0)
                    return;

                const values = value.split(":");
                let datas = this.dataSelecionada;

                datas[0].setHours(this.$_.parseInt(values[0]))
                datas[0].setMinutes(this.$_.parseInt(values[1]));
                datas[0].setSeconds(0);
                datas[0].setMilliseconds(0);                  

                this.$set(this, "dataSelecionada", datas);
            }
        },
        horaFinal:{
            get(){
                if(this.dataSelecionada[1] == null)
                    return null;

                return this.$moment(this.dataSelecionada[1]).format('HH:mm');
            },
            set(value){
                if(value == undefined || value.indexOf(":") < 0)
                    return;

                const values = value.split(":");
                let datas = this.dataSelecionada;

                datas[1].setHours(this.$_.parseInt(values[0]))
                datas[1].setMinutes(this.$_.parseInt(values[1]));
                datas[1].setSeconds(59);

                this.$set(this, "dataSelecionada", datas)                
            }
        }                                                                                                                        
    },
    async created(){
        this.formUniqueCode = "FORM.ONCO.00003";
        this.privilegeUniqueCode = "SELC";

        this.$set(this.showItem, "insert", await this.hasAccess(this.formUniqueCode, "INSE"));

        let lista = [];
        lista.push({ id: 1, nome: this.$t('Views.Onboarding.Log.Listar.item-indicador-inclusao')});

        lista.push({ id: 2, nome: this.$t('Views.Onboarding.Log.Listar.item-indicador-alteracao')});
        lista.push({ id: 3, nome: this.$t('Views.Onboarding.Log.Listar.item-indicador-nao-identificada')});
        this.$set(this.lista, "inclusaoAlteracao", lista);

        lista = [];
        lista.push({ id: 1, nome: this.$t('Views.Onboarding.Log.Listar.item-indicador-sucesso')});

        lista.push({ id: 2, nome: this.$t('Views.Onboarding.Log.Listar.item-indicador-erro')});
        this.$set(this.lista, "sucessoErro", lista);          
    },
    async mounted(){       
        const loading = this.showLoading();
        this.$set(this, "dataSelecionada", this.createPeriodFromNowToPast(0, "days"));

        if(this.pais == null && this.getUserCountry != null && !this.paisPadraoUsuario){
            this.paisPadraoUsuario = true;
            this.$set(this, "pais", this.getUserCountry);
        }

        await this.listarPais();
        loading.close();                
    },
    methods:{   
        async listarPais(){
            const paises = await ParametrizacaoOnboardingApi.listarPaises().catch(erro => this.showSnackbarError(erro.error));            

            if(paises.success) {
                this.$set(this.lista, "pais", this.$_.sortBy(paises.data, p => p.nome));
            }
            else {                        
                this.showSnackbarError(paises.error);
                throw new Error(paises.error[0].userMessage);
            }   
        },            
        async btnLimpar_OnClick(){
            this.$refs.form.reset();

            if(this.getUserCountry != null){
                this.$nextTick(() => {
                    this.$set(this, "paisPadraoUsuario", false);
                    this.$set(this, "pais", null);
                        
                });
            }         
            
            this.$set(this, "dataSelecionada", []);
            this.parametrosConsulta = null;            
        },          
        async btnPesquisar_OnClick(){
            const self = this;
            if(self.$refs.form.validate()){
                let dataInicial = self.dataSelecionada[0];
                let dataFinal = self.dataSelecionada[1];  

                self.resultado = [];
                self.paisGrid = self.pais;

                let indicadorSucesso = null;
                let indicadorInclusao = null;

                if(self.indicadorInclusao != null && self.indicadorInclusao.id == 1)
                    indicadorInclusao = true;

                else if(self.indicadorInclusao != null && self.indicadorInclusao.id == 2)
                    indicadorInclusao = false;       

                if(self.indicadorSucesso != null && self.indicadorSucesso.id == 1)
                    indicadorSucesso = true;

                else if(self.indicadorSucesso != null && self.indicadorSucesso.id == 2)
                    indicadorSucesso = false;

                this.parametrosConsulta = {
                    dataInicial: dataInicial,
                    dataFinal: dataFinal,
                    pais: self.pais,
                    correlationId: self.correlationId,
                    jobReqId: self.jobReqId,
                    indicadorInclusao: indicadorInclusao,            
                    indicadorSucesso: indicadorSucesso
                };
            }
        }      
    }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

</style>
